export default "__VITE_ASSET__BwfGYPE0__"